import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { ActivityBy } from "@/api/activity";
import { ActivityFeed } from "@/components/ActivityFeed";
import { AuthGate } from "@/components/AuthGate";
import { cn } from "@/lib/utils";

function ActivityPage() {
  const { t } = useTranslation();
  const [by, setBy] = useState<ActivityBy>("all");
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-xl font-semibold">{t("activity.title")}</h1>
        <div
          role="group"
          aria-label={t("activity.filter")}
          className="flex gap-1"
        >
          {(["all", "others"] as const).map((b) => (
            <button
              key={b}
              type="button"
              aria-pressed={by === b}
              onClick={() => setBy(b)}
              className={cn(
                "rounded-full border px-3 py-1 text-sm",
                by === b ? "border-primary bg-primary/10" : "hover:bg-accent",
              )}
            >
              {t(`activity.by_${b}`)}
            </button>
          ))}
        </div>
      </div>
      <p className="text-sm text-muted-foreground">{t("activity.intro")}</p>
      <ActivityFeed by={by} />
    </div>
  );
}

export const Route = createFileRoute("/activity")({
  component: function ActivityRoute() {
    return (
      <AuthGate>
        <ActivityPage />
      </AuthGate>
    );
  },
});
